package devxertech.com.pages.services.mobileServices

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.commons.ServiceArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.mobileServices.mobileAppDev.MobileStructured
import devxertech.com.pages.services.mobileServices.mobileDevelopmentSec.MobileDevSection
import devxertech.com.pages.services.mobileServices.mobileKeyFactor.MobileKeySection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/mobile-services")
@Composable
fun MobileAppSection() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
          image =   Res.Image.mobile_header,
            breakpoint = breakpoint,
            headingText = "Mobile App Development services",
            descriptionText = "Customized, specified and innovative solutions for Mobile App development."
        )
        ServiceArrow("Mobile App Development")
//        MobileAboutSection(breakpoint)
        CommonAboutSection(
            breakpoint,
            firstFont ="Unveiling Devxer",
            secondFont = "Mobile App Magic Formula",
            description = "At Devxer Technologies, we blend innovation, strategy, and creativity to craft stunning digital " +
                    "experiences. We aim to build apps that nail the concept of aptness, ease of use, and efficient performance. " +
                    "We ensure that our client’s sensitive data remains as safe as it can be. " +
                    "Our thorough and extremely professional approach allows the users to feel " +
                    "the comfort of reliable computing in this time of increased cyber threats. ",
            title = "What’s the Secret Behind",
            imageName = Res.Image.mobile_about
        )
        MobileKeySection()
        MobileStructured()
        MakeYourOwnTeam(breakpoint)
        MobileDevSection(breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}